import React from 'react';
import { StyleSheet, View } from 'react-native';

export const ContextualMenuSeparator: React.FC = () => {
  return <View style={styles.separator} />;
};

const styles = StyleSheet.create({
  separator: {
    height: 1,
    backgroundColor: '#EEEEEE',
  },
});
